import { Controller } from "@hotwired/stimulus"
import type { DateRangeSelection } from "./date_range_calendar_controller"

const DAY = 86400000

// Passes return the day after the calendar's last selected night.
export default class extends Controller {
  static targets = ["leave", "return", "summary"]
  static values = { locale: String, summaryOne: String, summaryOther: String }
  declare readonly leaveTarget: HTMLInputElement
  declare readonly returnTarget: HTMLInputElement
  declare readonly summaryTarget: HTMLElement
  declare readonly localeValue: string
  declare readonly summaryOneValue: string
  declare readonly summaryOtherValue: string

  connect() { this.renderSummary() }

  update(event: CustomEvent<DateRangeSelection>) {
    this.leaveTarget.value = event.detail.start
    this.returnTarget.value = new Date(Date.parse(event.detail.end) + DAY).toISOString().slice(0, 10)
    this.renderSummary()
  }

  private renderSummary() {
    const end = new Date(this.returnTarget.value)
    const nights = (end.getTime() - Date.parse(this.leaveTarget.value)) / DAY
    this.summaryTarget.hidden = !Number.isFinite(nights) || nights <= 0
    if (this.summaryTarget.hidden) return

    const template = nights === 1 ? this.summaryOneValue : this.summaryOtherValue
    const returnDate = new Intl.DateTimeFormat(this.localeValue, { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }).format(end)
    this.summaryTarget.textContent = template.replace("%{count}", String(nights)).replace("%{return}", returnDate)
  }
}
